import React, {MutableRefObject, useCallback} from 'react'
import {createPortal} from 'react-dom'

import Popover from "../../../gd-popover/popover-v2"
import PopoverPosition from "../../../gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../gd-popover/@const"
import PopoverMenuItem from "../../../popover-menu/popover-menu/menu-item"
import {AutoEmbedOption} from "@lexical/react/LexicalAutoEmbedPlugin"

const popoverPosition = new PopoverPosition({
    attachment      : "bottom left",
    targetAttachment: "top left",
    attachmentType  : PopoverAttachmentType.HORIZONTAL,
})

export function EmbedMenu (
    anchorElementRef: MutableRefObject<HTMLElement | null>, itemProps: {
        selectedIndex: number | null;
        selectOptionAndCleanUp: (option: AutoEmbedOption) => void;
        setHighlightedIndex: (index: number) => void;
        options: Array<AutoEmbedOption>;
    }, matchingString: string | null
) {
    if (!anchorElementRef.current || !itemProps.options.length) return null

    const onClick = (index:number, option:AutoEmbedOption) => {
        itemProps.setHighlightedIndex(index)
        itemProps.selectOptionAndCleanUp(option)
    }

    const onPopoverHide = useCallback(()=>{
        if (anchorElementRef.current) {
            gd.utils.Dom.removeClass(anchorElementRef.current,"visible")
        }
    }, [])

    if (anchorElementRef.current) {
        gd.utils.Dom.addClass(anchorElementRef.current,"visible")
    }

    return createPortal(
        <Popover position         = {popoverPosition}
                 onPopoverHide      = {onPopoverHide}
                 getTargetFunc      = {()=>anchorElementRef.current}>
            <div className="ui5-popover-menu icon-fs-16" style={{minWidth:180}}>
                {_.map(itemProps.options, (option:AutoEmbedOption, index:number) => (
                    <PopoverMenuItem key            = {index}
                                     label          = {option.title}
                                     isHighlighted  = {index === itemProps.selectedIndex}
                                     onClick          = {()=>onClick(index, option)}/>
                ))}
            </div>
        </Popover>,
        anchorElementRef.current,
    )
}
